import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthUser from './AuthUser';
import toast, { Toaster } from 'react-hot-toast';

export default function AddAgentStudent() {
    const navigate = useNavigate();
    const { http, user } = AuthUser();
    const [users, setUsers] = useState([]);
    const [classes, setClasses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        user_id: '',
        company_id: user.company_id,
        student_name: '',
        class: '',
        mobile_number: '',
        email_address: '',
        father_name: '',
        status: 0 // Default to not approved
    });

    useEffect(() => {
        fetchUsers();
        fetchClasses();
    }, []);

    const fetchUsers = () => {
        // Use the API endpoint to fetch users filtered by coFFmpany and department 4
        http.get(`/users_by_company_department?company_id=${user.company_id}&department_id=4`)
            .then((res) => {
                if (res.data.success && Array.isArray(res.data.users)) {
                    setUsers(res.data.users);
                    if (res.data.users.length === 0) {
                        toast.info("No users found with department ID 4");
                    }
                } else {
                    console.error("API response for users is not as expected:", res.data);
                    toast.error("Failed to load users");
                }
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
                toast.error("Error loading users");
            });
    };
    
    const fetchClasses = () => {
        http.get(`/class?company_id=${user.company_id}`)
            .then((res) => {
                if (Array.isArray(res.data.data)) {
                    setClasses(res.data.data);
                } else {
                    console.error("API response for classes is not an array");
                    toast.error("Failed to load classes");
                }
            })
            .catch((error) => {
                console.error("Error fetching classes:", error);
                toast.error("Error loading classes");
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await http.post('/agent_student_add', formData);
            
            if (response.data.success) {
                toast.success("Student added successfully!");
                navigate('/agent_student_list');
            } else {
                toast.error(response.data.message || "Failed to add student");
            }
        } catch (error) {
            console.error("Error adding student:", error);
            toast.error(error.response?.data?.message || "An error occurred while adding the student");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="container mt-5">
                <Toaster />
                <h3>Add Consult Student</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group mt-3">
                        <label>Select Consult <span className="text-danger">*</span></label>
                        <select 
                            id="user_id"
                            name="user_id"
                            className="form-control"
                            value={formData.user_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Consult</option>
                            {users.map(user => (
                                <option key={user.id} value={user.id}>
                                    {user.name} {user.last_name || ''} ({user.email})
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group mt-3">
                        <label>Student Name <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            id="student_name"
                            name="student_name"
                            className="form-control"
                            value={formData.student_name}
                            onChange={handleChange}
                            required
                            placeholder="Enter student name"
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>Class</label>
                        <select
                            id="class"
                            name="class"
                            className="form-control"
                            value={formData.class}
                            onChange={handleChange}
                        >
                            <option value="">Select a class</option>
                            {classes.map((classItem) => (
                                <option key={classItem.id} value={classItem.class_name}>
                                    {classItem.class_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group mt-3">
                        <label>Mobile Number</label>
                        <input
                            type="text"
                            id="mobile_number"
                            name="mobile_number"
                            className="form-control"
                            value={formData.mobile_number}
                            onChange={handleChange}
                            placeholder="Enter mobile number"
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>Email Address</label>
                        <input
                            type="email"
                            id="email_address"
                            name="email_address"
                            className="form-control"
                            value={formData.email_address}
                            onChange={handleChange}
                            placeholder="Enter email address"
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>Father's Name</label>
                        <input
                            type="text"
                            id="father_name"
                            name="father_name"
                            className="form-control"
                            value={formData.father_name}
                            onChange={handleChange}
                            placeholder="Enter father's name"
                        />
                    </div>

                    <div className="mt-4">
                        <button 
                            type="submit" 
                            className="btn btn-success me-2"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Adding...' : 'Add Student'}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-secondary" 
                            onClick={() => navigate('/agent_student_list')}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}
